import React, { useState } from 'react';
import { IconSymbol } from '@abyss/web/ui/IconSymbol';
import { V2Button } from '@abyss/web/ui/Button';

import classNames from 'classnames';

import styles from './additems.module.css';

export const AddItems = ({ type = 'doctors' }) => {
  const [typeSelected, setTypeSelected] = useState('');

  const drugItems = [
    { icon: true, name: 'baclofen TAB 10MG' },
    { icon: false, name: 'Acetaminophen TAB 325MG' },
    { icon: false, name: 'Acetaminophen TAB 325MG' },
    { icon: false, name: 'Acetaminophen TAB 325MG' },
    { icon: false, name: 'Taltz INJ 80MG/ML (Auto-Injector)' },
    { icon: false, name: 'Taltz INJ 80MG/ML (Auto-Injector)' },
    { icon: false, name: 'Taltz INJ 80MG/ML (Auto-Injector)' },
    { icon: false, name: 'MECORIX EMULSION' },
    { icon: false, name: 'MECORIX EMULSION' },
    { icon: false, name: 'MECORIX EMULSION' },
    { icon: false, name: 'Glumetza TAB 500MG' },
    { icon: false, name: 'Glumetza TAB 500MG' },
    { icon: false, name: 'Azasite SOL 1%' },
    { icon: false, name: 'Prilosec OTC TAB 20MG' },
    { icon: false, name: 'Norvasc TAB 5MG' },
    { icon: true, name: 'levothyroxine sodium (tablets) TAB 75MCG' },
    { icon: false, name: 'Qbrelis SOL 1MG/ML' },
    { icon: false, name: 'Zocor TAB 20MG' },
    { icon: false, name: 'Zocor TAB 5MG' },
    { icon: true, name: 'levothyroxine sodium (tablets) TAB 75MCG' },
    { icon: false, name: 'Qbrelis SOL 1MG/ML' },
    { icon: false, name: 'Qbrelis SOL 1MG/ML' },
    { icon: false, name: 'Zocor TAB 20MG' },
    { icon: false, name: 'Zocor TAB 20MG' },
    { icon: false, name: 'Zocor TAB 20MG' },
  ];

  const drugList = Array.from(Object.entries(drugItems), ([key, value]) => {
    return (
      <li className={styles.drugItem}>
        <div className={styles.drugItemIcon}>
          {value.icon && (
            <IconSymbol icon="check_circle" size="16px" color="#007000" />
          )}
          {!value.icon && (
            <IconSymbol icon="cancel" size="16px" color="#C40000" />
          )}
        </div>
        <div>{value.name}</div>
      </li>
    );
  });

  return (
    <div>
      <div>
        {typeSelected !== 'drugs' && typeSelected !== 'estimated' && (
          <V2Button
            variant="text"
            className={styles.thebutton}
            onClick={() => {
              setTypeSelected(type);
            }}
          >
            <span className={styles.wrap}>
              <span className={styles.icon}>
                <IconSymbol
                  icon="add_box"
                  color="#002677"
                  variant="outlined"
                  size="22px"
                />
              </span>
              {typeSelected === '' && type === 'estimated' && (
                <span>Add your drugs</span>
              )}

              {typeSelected === '' && type !== 'estimated' && (
                <span>Add your {type}</span>
              )}

              {typeSelected === 'doctors' && <span>Add/edit doctors</span>}

              {typeSelected === 'dentists' && <span>Add/edit dentists</span>}
            </span>
          </V2Button>
        )}
      </div>

      {typeSelected === 'doctors' && (
        <div className={styles.cardContainer}>
          <div className={styles.doctorsWrap}>
            <div className={styles.doctorBox}>
              <div className={styles.doctorBoxInner}>
                <div className={styles.doctorBoxIcon}>
                  <IconSymbol size="20px" icon="check_circle" color="#007000" />
                </div>
                <div className={styles.doctorBoxContent}>
                  <div>Wilson, Natalie K, MD</div>
                  <div>2540 Windy Hill Rd SE Marietta, MN 55416</div>
                  <div>(Accepts Medicare patients)</div>
                </div>
              </div>
            </div>

            <div className={styles.doctorBox}>
              <div className={styles.doctorBoxInner}>
                <div className={styles.doctorBoxIcon}>
                  <IconSymbol size="20px" icon="cancel" color="#C40000" />
                </div>
                <div className={styles.doctorBoxContent}>
                  <div>Dawson, Brian Jefferson, MD</div>
                  <div>3330 Piedmont Rd Ne Ste 13, Minneapolis, MN 55416</div>
                  <div>(Accepts Medicare patients)</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {typeSelected === 'dentists' && (
        <div className={styles.cardContainer}>
          <div className={styles.doctorsWrap}>
            <div className={styles.doctorBox}>
              <div className={styles.doctorBoxInner}>
                <div className={styles.doctorBoxIcon}>
                  <IconSymbol size="20px" icon="check_circle" color="#007000" />
                </div>
                <div className={styles.doctorBoxContent}>
                  <div>Anderson, Natalie K, DDS</div>
                  <div>2540 Windy Hill Rd SE Marietta, MN 55416</div>
                  <div>(Accepts Medicare patients)</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {typeSelected === 'drugs' && (
        <div>
          <div className={styles.cardContainer}>
            <div className={styles.drugWrap}>
              <div>
                <div className={styles.drugSectionButton}>
                  <V2Button
                    variant="text"
                    className={styles.thebutton}
                    onClick={() => {
                      setTypeSelected(type);
                    }}
                  >
                    <span className={styles.wrap}>
                      <span className={styles.icon}>
                        <IconSymbol
                          icon="local_pharmacy"
                          color="#196ECF"
                          variant="outlined"
                          size="24px"
                        />
                      </span>
                      <span>Edit your pharmacy</span>
                    </span>
                  </V2Button>
                </div>
                <div className={styles.drugBox}>
                  <div className={styles.drugBoxInner}>
                    <div className={styles.doctorBoxContent}>
                      <div className={styles.pharmacy}>
                        Walgreens{' '}
                        <IconSymbol
                          icon="warning"
                          color="#196ECF"
                          size="18px"
                        />
                      </div>
                      <div>3240 W Lake St, Minneapolis, MN 55416</div>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <div className={styles.drugSectionButton}>
                  <V2Button
                    variant="text"
                    className={styles.thebutton}
                    onClick={() => {
                      setTypeSelected(type);
                    }}
                  >
                    <span className={styles.wrap}>
                      <span className={styles.icon}>
                        <IconSymbol
                          icon="visibility"
                          color="#196ECF"
                          variant="outlined"
                          size="24px"
                        />
                      </span>
                      <span>View drug costs by month</span>
                    </span>
                  </V2Button>
                </div>
                <div className={styles.drugBox}>
                  <div className={styles.drugBoxInner}>
                    <div className={styles.doctorBoxContent}>
                      <div className={styles.estimated}>
                        Estimated annual drug cost
                      </div>
                      <div className={styles.estimatedTotal}>$152.124.66</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className={styles.drugListingWrap}>
            <V2Button
              variant="text"
              className={styles.thebutton}
              onClick={() => {
                setTypeSelected(type);
              }}
            >
              <span className={styles.wrap}>
                <span className={styles.icon}>
                  <IconSymbol
                    icon="add_box"
                    color="#002677"
                    variant="outlined"
                    size="22px"
                  />
                </span>
                <span>Add/edit drugs</span>
              </span>
            </V2Button>

            <ul className={styles.drugListing}>{drugList}</ul>
          </div>
        </div>
      )}

      {typeSelected === 'estimated' && (
        <div className={styles.estimatedWrap}>
          <div className={styles.estimatedTotal}>$152.124.66</div>
          <div className={styles.edit}>
            <V2Button variant="text">Edit</V2Button>
          </div>
        </div>
      )}
    </div>
  );
};
